module.exports = __webpack_public_path__ + "img/E-WEB-Goal-7.73ac8800.png";